import { Link } from "react-router-dom";

/** Elegant BeforeExam logo: shield crest with monogram + dual-tone wordmark + gold tagline. */
export default function Logo({ size = "default", to = "/", showTagline = true, className = "" }) {
  const sizes = {
    default: { mark: 36, text: "text-xl", tag: "text-[9px]" },
    sm: { mark: 30, text: "text-base", tag: "text-[8px]" },
    lg: { mark: 56, text: "text-3xl", tag: "text-[11px]" },
  };
  const s = sizes[size] || sizes.default;

  const Inner = (
    <div className={`flex items-center gap-3 shrink-0 ${className}`}>
      <span className="relative inline-flex shrink-0" style={{ width: s.mark, height: s.mark }}>
        <svg viewBox="0 0 56 56" width={s.mark} height={s.mark} aria-hidden>
          <defs>
            <linearGradient id="be-shield-fill" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#1A2A6C" />
              <stop offset="60%" stopColor="#0F1A4D" />
              <stop offset="100%" stopColor="#0A1238" />
            </linearGradient>
            <linearGradient id="be-shield-bevel" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#F2C95C" />
              <stop offset="100%" stopColor="#C9943A" />
            </linearGradient>
            <linearGradient id="be-mono" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#FBE08A" />
              <stop offset="100%" stopColor="#E8B547" />
            </linearGradient>
          </defs>
          {/* Shield body */}
          <path
            d="M28 2 L52 10 L52 28 C52 42 41 51 28 54 C15 51 4 42 4 28 L4 10 Z"
            fill="url(#be-shield-fill)"
            stroke="url(#be-shield-bevel)"
            strokeWidth="1.4"
          />
          {/* Inner highlight */}
          <path
            d="M28 6 L48 12.5 L48 28 C48 39.5 39 47 28 49.5 C17 47 8 39.5 8 28 L8 12.5 Z"
            fill="none"
            stroke="rgba(255,255,255,0.07)"
            strokeWidth="1"
          />
          {/* Monogram B with elegant serif feel */}
          <text
            x="50%"
            y="56%"
            textAnchor="middle"
            dominantBaseline="middle"
            fontFamily="Fraunces, Georgia, serif"
            fontWeight="900"
            fontSize="30"
            fill="url(#be-mono)"
            fontStyle="italic"
          >
            B
          </text>
          {/* Tiny ornament dots */}
          <circle cx="28" cy="13" r="1.4" fill="#F2C95C" opacity="0.85" />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-display ${s.text} tracking-tight`}>
          <span>Before</span>
          <span className="font-serif text-gradient-gold ml-0.5">Exam</span>
        </span>
        {showTagline && (
          <span className={`mt-1 hidden sm:inline ${s.tag} font-bold uppercase tracking-[0.28em] text-[color:var(--brand-gold-deep)] dark:text-[#F2C95C]`}>
            Prep · Practice · Pass
          </span>
        )}
      </span>
    </div>
  );

  if (!to) return Inner;
  return <Link to={to} aria-label="BeforeExam — home" data-testid="logo-link">{Inner}</Link>;
}
